<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex xs12 md6 lg4 d-flex>
                    <v-card flat dark>
                        <v-card-title primary-title>
                            <div>
                                <div class="headline">Verification</div>
                            </div>
                        </v-card-title>
                        <v-card-text class="text-xs-center">
                            <template v-if="verified">
                                <v-btn flat block color="success">Verified
                                    <v-icon right>check_circle</v-icon>
                                </v-btn>
                                <p>User has successfully verified their email address</p>
                            </template>
                            <template v-else-if="verificationInProgress">
                                <v-btn flat block color="warning">Pending
                                    <v-icon right>warning</v-icon>
                                </v-btn>
                                <p>User has been sent a verification email</p>
                            </template>
                            <template v-else>
                                <v-btn flat block disabled>Not Started
                                    <v-icon right>error</v-icon>
                                </v-btn>
                                User has not started the verification process
                            </template>
                        </v-card-text>
                        <v-card-text class="text-xs-center">
                            {{userEmail}}
                        </v-card-text>
                        <v-card-text v-if="verificationInProgress">
                            <loading loadingMessage="Loading verification progress..." v-if="loadingData"></loading>
                            <template v-else>
                                <v-list two-line>
                                    <template v-for="(item, index) in verificationProgress">
                                        <v-list-tile :key="index" avatar>
                                            <v-list-tile-avatar>
                                                <v-icon>{{getEventIcon(item.event)}}</v-icon>
                                            </v-list-tile-avatar>

                                            <v-list-tile-content>
                                                <v-list-tile-title>{{getEventTitle(item.event)}} {{getReason(item)}}</v-list-tile-title>
                                                <v-list-tile-sub-title>{{formatTimestamp(item.timestamp)}}
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                                <v-list
                                        two-line
                                >
                                    <v-divider></v-divider>
                                    <v-list-tile avatar :color="expiresColour">
                                        <v-list-tile-avatar>
                                            <v-icon>timer</v-icon>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Token {{tokenExpired ? 'Expired' : 'Valid Until:'}}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{verificationToken ? formatTimestamp(verificationToken.expires) : 'N/A'}}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                </v-list>
                                <v-list
                                        subheader
                                        three-line
                                        dense
                                >
                                    <v-subheader>Solutions</v-subheader>

                                    <v-list-tile @click="" :to="{name: 'admin.user.profile', params: {uid: userModel.uid}}">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Change Email Address</v-list-tile-title>
                                            <v-list-tile-sub-title>If the user has made a typo then you can change their
                                                email address
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile @click="$refs.resetVerificationDialog.openDialog()">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Reset Verification</v-list-tile-title>
                                            <v-list-tile-sub-title>Resets the user verification so that they can start again
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile @click="$refs.manualVerificationDialog.openDialog()">
                                        <v-list-tile-content>
                                            <v-list-tile-title>Manual Verification</v-list-tile-title>
                                            <v-list-tile-sub-title>Effectively skips the verification process for the user</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                                <reset-user-verification ref="resetVerificationDialog" :userModel="userModel"></reset-user-verification>
                                <manual-user-verification ref="manualVerificationDialog" :userModel="userModel"></manual-user-verification>
                            </template>
                        </v-card-text>
                        <v-card-text v-if="notStarted">
                            <v-list
                                    subheader
                                    three-line
                                    dense
                            >
                                <v-subheader>Solutions</v-subheader>

                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Respond to User</v-list-tile-title>
                                        <v-list-tile-sub-title>Instruct the user to start the verification process by
                                            logging in and following the on screen directions
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs12 md6 lg4 d-flex>
                    <v-card flat dark>
                        <v-card-title primary-title>
                            <div>
                                <div class="headline">Password Reset</div>
                            </div>
                        </v-card-title>
                        <v-card-text>
                            If the user is having trouble requesting a password reset then you can manually change their
                            password.
                            However, this is a last resort. Try to find out why they can't receive the password reset email.
                        </v-card-text>
                        <v-card-text>
                            <v-list
                                    subheader
                                    three-line
                                    dense
                            >
                                <v-subheader>Solutions</v-subheader>

                                <v-list-tile @click="" :to="{name: 'admin.user.troubleshoot.password', params: {uid: userModel.uid}}">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Change Password</v-list-tile-title>
                                        <v-list-tile-sub-title>Manually set the user's login password</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
  import _ from 'lodash'
  import ResetUserVerification from '@/views/app/user/components/ResetUserVerification'
  import ManualUserVerification from '@/views/app/user/components/ManualUserVerification'

  export default {
    name: 'UserTroubleshoot',
    components: {ResetUserVerification, ManualUserVerification},
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      },
      userModel: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        active: null,
        loadingStatus: false,
        loadingToken: false,
        verificationStatus: [],
        verificationToken: null,
        verificationStatusRef: null,
        verificationTokenRef: null,
        resetVerificationDialog: false
      }
    },
    created () {
      const self = this

      if (self.userModel && self.userModel.hasOwnProperty('verification')) {
        self.getVerificationStatus(self.userModel.uid, self.userModel.verification.messageUUID)
        self.getVerificationToken(self.userModel.uid)
      }
    },
    computed: {
      userEmail () {
        if (!this.userModel.hasOwnProperty('profile') || !this.userModel.profile.hasOwnProperty('email')) return 'Email address not available (account registration incomplete)'
        return this.userModel.profile.email
      },
      verified () {
        return this.userModel.emailVerified
      },
      verificationInProgress () {
        return !!this.userModel.verification
      },
      notStarted () {
        return !this.verified && !this.verificationInProgress
      },
      verificationProgress () {
        const self = this
        if (!self.verificationStatus) {
          return []
        }
        return _.sortBy(self.verificationStatus, [(o) => o.timestamp])
      },
      tokenExpired () {
        const self = this
        if (!self.verificationToken) return false

        const expires = new Date(self.verificationToken.expires * 1000)
        const now = new Date()

        return expires < now
      },
      loadingData () {
        return this.loadingStatus || this.loadingToken
      },
      hubURL () {
        return this.systemConfig.urls.app
      },
      reverify () {
        if (!this.userModel || !this.userModel.hasOwnProperty('permissions')) return false
        return this.userModel.permissions.grants.users[this.userModel.uid].includes('reverify')
      },
      verifyLink() {
        const self = this
        let action = 'activate'

        if (!self.verificationToken || !self.verificationToken.hasOwnProperty('token')) return 'N/A'

        if (self.reverify) {
          action = 'reactivate'
        }

        return `${self.hubURL}/account/${action}?uid=${self.userModel.uid}&token=${self.verificationToken.token}`
      },
      expiresColour () {
        if (this.tokenExpired) return 'error'
        return undefined
      }
    },
    methods: {
      getVerificationStatus (userUID, messageUUID) {
        const self = this
        self.loadingStatus = true
        self.verificationStatusRef = self.$firebaseClient.getUserNotificationStatus(userUID, messageUUID).on('value', snapshot => {
          self.verificationStatus = snapshot.val()
          self.loadingStatus = false
        })
      },
      getVerificationToken (userUID) {
        const self = this
        self.loadingToken = true
        self.verificationTokenRef = self.$firebaseClient.getUserVerificationToken(userUID).on('value', snapshot => {
          self.verificationToken = snapshot.val()
          self.loadingToken = false
        })
      },
      getEventTitle (event) {
        switch (event) {
          case 'email-requested':
            return 'Requested'
          case 'processed':
            return 'Processed'
          case 'delivered':
            return 'Delivered'
          case 'dropped':
            return 'Dropped'
          case 'click':
            return 'Link clicked'
          case 'open':
            return 'Email Opened'
          default:
            return 'Unrecognised Event'
        }
      },
      getReason (event) {
        switch (event.event) {
          case 'dropped':
            return `(${event.reason})`
          default:
            return ''
        }
      },
      getEventIcon (event) {
        switch (event) {
          case 'email-requested':
            return 'create'
          case 'processed':
            return 'send'
          case 'delivered':
            return 'receipt'
          case 'dropped':
            return 'Dropped'
          case 'open':
            return 'email'
          case 'click':
            return 'touch_app'
          case 'error':
            return 'error'
          default:
            return 'error'
        }
      },
      formatTimestamp (timestamp) {
        const ts = new Date(timestamp * 1000)
        return `${ts.getUTCFullYear()}-${('0' + (ts.getUTCMonth() + 1)).slice(-2)}-${ts.getUTCDate()} ${ts.getUTCHours()}:${ts.getUTCMinutes()}:${ts.getUTCSeconds()}`
      },
      resetVerification () {
        // TODO: set loading status
        // TODO: call api
        // TODO: close dialog
        // TODO: use toast to indicate success
        const self = this
        self.resettingVerification = true
        self.verificationTokenRef = self.$firebaseClient.getUserVerificationToken(userUID).on('value', snapshot => {
          self.verificationToken = snapshot.val()
          self.resettingVerification = false
        })
      }
    },
    watch: {
      'userModel' (newVal) {
        const self = this
        if (newVal.hasOwnProperty('verification')) {
          self.getVerificationStatus(newVal.uid, newVal.verification.messageUUID)
          self.getVerificationToken(newVal.uid)
        }
      }
    }
  }
</script>

<style scoped>

</style>